// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Css_Js_Core = require("bs-css/src/Css_Js_Core.bs.js");
var Type_Header = require("../../../type/Type_Header.bs.js");
var Particle_Css = require("../../particle/Particle_Css.bs.js");
var Particle_zIndex = require("../../particle/Particle_zIndex.bs.js");
var Particle_Screen_Ds = require("../../particle/Particle_Screen_Ds.bs.js");

var zIndexRule = Particle_zIndex.Particle_zIndex_Css.toCss({
      TAG: /* Exact */0,
      _0: /* Header */7
    });

var scrollableHeightCalculation = CssJs.height(Css_Js_Core.Calc.$neg(CssJs.vh(100), Particle_Css.pxToRem(Type_Header.Constants.height.default)));

var rules = Particle_Screen_Ds.make(undefined, undefined, [
      CssJs.right(CssJs.inherit_),
      CssJs.height(CssJs.auto),
      CssJs.top(Particle_Css.pxToRem(Type_Header.Constants.height.m))
    ], undefined, undefined, [
      CssJs.position(CssJs.absolute),
      CssJs.top(Particle_Css.pxToRem(Type_Header.Constants.height.default)),
      zIndexRule,
      scrollableHeightCalculation,
      CssJs.left(CssJs.px(0)),
      CssJs.right(CssJs.px(0)),
      CssJs.overflow(CssJs.auto)
    ]);

var MenuNavigation = {
  rules: rules
};

var rules$1 = Particle_Screen_Ds.make(undefined, undefined, [CssJs.top(Particle_Css.pxToRem(Type_Header.Constants.height.m))], undefined, undefined, [
      CssJs.position(CssJs.absolute),
      CssJs.top(Particle_Css.pxToRem(Type_Header.Constants.height.default)),
      zIndexRule,
      CssJs.right(CssJs.px(0)),
      CssJs.overflow(CssJs.auto),
      CssJs.minWidth(CssJs.pct(100)),
      CssJs.unsafe("width", "max-content")
    ]);

var LanguageSwitcher = {
  rules: rules$1
};

function makeRules(ffNewConcertHeader) {
  if (ffNewConcertHeader) {
    return Particle_Screen_Ds.make(undefined, undefined, [CssJs.top(Particle_Css.pxToRem(Type_Header.Constants.height.m))], undefined, undefined, [
                CssJs.minWidth(CssJs.pct(100)),
                CssJs.position(CssJs.absolute),
                CssJs.top(Particle_Css.pxToRem(Type_Header.Constants.height.default))
              ]);
  } else {
    return Particle_Screen_Ds.make(undefined, undefined, [CssJs.top(Particle_Css.pxToRem(Type_Header.Constants.height.m))], undefined, undefined, [
                CssJs.position(CssJs.absolute),
                CssJs.top(Particle_Css.pxToRem(Type_Header.Constants.height.default)),
                zIndexRule,
                CssJs.left(CssJs.px(0)),
                CssJs.overflow(CssJs.auto),
                CssJs.minWidth(CssJs.pct(100)),
                scrollableHeightCalculation
              ]);
  }
}

var ConcertMenuNavigation = {
  makeRules: makeRules
};

exports.zIndexRule = zIndexRule;
exports.scrollableHeightCalculation = scrollableHeightCalculation;
exports.MenuNavigation = MenuNavigation;
exports.LanguageSwitcher = LanguageSwitcher;
exports.ConcertMenuNavigation = ConcertMenuNavigation;
/* zIndexRule Not a pure module */
